import { FC } from 'react'
import { useSearchParams } from 'react-router-dom'

import { ResourceHeader } from '@factorialco/factorial-one-react/dist/experimental'
import { Add } from '@factorialco/factorial-one-react/icons/app'
import { EmployeeGoalsHeaderFragment } from 'generated/resources/graphql'

import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

export const EmployeeGoalsHeader: FC<{
  goalsEmployee: EmployeeGoalsHeaderFragment
}> = ({ goalsEmployee }) => {
  const [_searchParams, setSearchParams] = useSearchParams()

  // TODO once we remove ResponsivePage's header, move CreateMetricModal from EmployeePage to this component
  const openCreateDialog = () => setSearchParams({ modal: 'create' })

  const employee = goalsEmployee.employee

  const canCreateMetricGroups = goalsEmployee?._policies?.createMetric?.can

  return (
    <ResourceHeader
      title={employee?.fullName || ''}
      description={employee?.referenceContract?.jobTitle || ''}
      avatar={{
        src: buildUrl(employee?.access.avatar),
        firstName: employee?.firstName || '',
        lastName: employee?.lastName || '',
        type: 'person',
      }}
      primaryAction={
        canCreateMetricGroups
          ? {
              label: i18n.t('performance_goals.pages.employee_page.create_button'),
              icon: Add,
              onClick: openCreateDialog,
            }
          : undefined
      }
    />
  )
}
